import { useTypedQuery } from "hooks/useTypedQuery";
import { useDealerLicensesDashboardFilters } from "modules/DealerLicenseOverview/hooks/useDealerLicensesFilters";
import { DealerLicenseQueryKeys } from "modules/DealerLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDealerItemsQuery = () => {
  const { dealer } = useDealerLicensesDashboardFilters();

  const { data, isLoading } = useTypedQuery({
    queryKey: DealerLicenseQueryKeys.licenseItems,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_id: dealer?.id }, baseUrl)).data.items,
    enabled: Boolean(dealer)
  });

  return { dealerItems: data ?? [], isLoadingDealerItems: isLoading };
};
